import { VStack, Text, Box, Badge, Spacer } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import MatchingScore from '../../../../../../../../common/src/components/MatchingScore';
import ActiveButton from '../../shared/ActiveButton';
import ComparisonMatrixOfferHeader from '../../mobile/header/ComparisonMatrixOfferHeader';
import useIsNewRoute from '../../../../../offers/hooks/useIsNewRoute';

interface Props {
  Icon: React.ReactElement;
  insuranceCompany: string;
  insuranceName: string;
  premium: string;
  interval: string;
  score: number;
  bestOffer?: boolean;
  isSelected: boolean;
  addToSelectedOffers: () => void;
  removeFromSelectedOffers: () => void;
}

const ComparisonMatrixOffer: React.FC<React.PropsWithChildren<Props>> = ({
  Icon,
  insuranceCompany,
  insuranceName,
  premium,
  interval,
  score,
  bestOffer,
  isSelected,
  addToSelectedOffers,
  removeFromSelectedOffers,
  ...otherProps
}) => {
  const { t } = useTranslation();
  const isNewRoute = useIsNewRoute();

  return (
    <Box justifySelf="center" pr="6" _last={{ pr: 0 }} {...otherProps}>
      <VStack
        justify="space-between"
        w="100%"
        h="100%"
        pos="relative"
        borderTopRadius="md"
        border="1px solid"
        borderColor={bestOffer ? 'primary.500' : 'gray.100'}
        borderBottom="none"
        p="4"
        spacing="4"
      >
        <VStack>
          {bestOffer && (
            <Badge
              pos="absolute"
              transform="translate(-50%, 50%)"
              left="50%"
              bottom="100%"
            >
              {t('Best match for you')}
            </Badge>
          )}
          <ComparisonMatrixOfferHeader
            Icon={Icon}
            title={insuranceCompany}
            description={insuranceName}
          />
        </VStack>
        <VStack spacing="2">
          <VStack spacing="0">
            <Text textStyle="h6Headline">{premium}</Text>
            <Text color="text.gray" textStyle="smallBody">
              {t(`spread.${interval.toUpperCase()}`)}
            </Text>
          </VStack>
          <MatchingScore score={score} />
        </VStack>
        {isNewRoute ? (
          <Spacer />
        ) : (
          <ActiveButton
            onClick={
              isSelected ? removeFromSelectedOffers : addToSelectedOffers
            }
            isActive={isSelected}
          >
            {isSelected
              ? t('Remove from chosen offers')
              : t('Add to chosen offers')}
          </ActiveButton>
        )}
      </VStack>
    </Box>
  );
};

export default ComparisonMatrixOffer;
